import * as React from "react";

/**
 * Whether a CSS media query matches, kept current as the window changes.
 *
 * For layout decisions that change *what* renders rather than how it looks — which a class like
 * `md:flex` cannot express without both versions sitting in the DOM at once, each with its own
 * focus target and its own timers.
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = React.useCallback(
    (notify: () => void) => {
      const list = window.matchMedia(query);
      list.addEventListener("change", notify);
      return () => list.removeEventListener("change", notify);
    },
    [query],
  );
  return React.useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    () => false,
  );
}
